import { createContext, ReactNode, useContext } from 'react';

interface MenuGroup {
    name: string,
    label: string,
    isOpen: boolean,
}

interface Context {
    menuGroups: Array<MenuGroup>,
}

const DEFAULTCONTEXT: Context = {
    menuGroups: [],
};

const RaMenuContext = createContext<Context>(DEFAULTCONTEXT)

export const useRaMenuContext = () => useContext(RaMenuContext);

interface RaMenuProviderProps {
    children: ReactNode,
    menuGroups: Array<MenuGroup>,
}

const RaMenuProvider = ({ children, menuGroups, ...rest }: RaMenuProviderProps) => {
    return (
        <RaMenuContext.Provider value={{menuGroups}}>
            {children}
        </RaMenuContext.Provider>
    )
}

export default RaMenuProvider;
